import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';
import { CommonConfig } from '../../../config/common-config';
import moment from 'moment';
// import ButtonComp from '../../button';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    // },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },

        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
export default function ItechGeneralInformation(props) {
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [itecOpen, setItecOpen] = React.useState(false);
    const [values, setValues] = React.useState({
        firstName: '',
        lastName: '',
        firstNamePan: '',
        pan: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        pin: '',
        dob: '',
        mobileNo: '',
        emailAddress: '',
        passportNumber: '',
        // weightRange: '',
        // showPassword: false,
        aadharNo: '',
    });
    //console.log('values from child', values);

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
        if (prop === 'country') {
            fetchStateData(event.target.value);
        } else if (prop === 'state') {
            fetchCityData(event.target.value);
        }
        // props.generalInformationData({ ...values, [prop]: event.target.value });
    };
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [allCities, setAllCities] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedState, setselectedState] = useState('');
    const [selectedCity, setselectedCity] = useState('');
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                //console.log('THE FETCHED DATA : ', response);
                setAllCountries(response.data);
            })
            .catch((error) => {
                //   //console.log(error);
            });
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                //  //console.log('THE FETCHED DATA : ', response);
                setAllStates(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    const fetchCityData = (data) => {
        axios.get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig).then((response) => {
            //  //console.log('THE FETCHED DATA : ', response);
            setAllCities(response.data);
        });
        // .catch((error) => {
        //     //console.log(error);
        // });
    };

    useEffect(() => {
        fetchCountryData();
    }, [bearerToken]);
    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };
    return (
        <>
            <Grid container spacing={3} className="main-container">
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="first-name">First Name</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.fatherName}
                            onChange={handleChange('firstName')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            // onClick={handleClickOpen}
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="last-name">Last Name</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.lastName}
                            onChange={handleChange('lastName')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fathers-name">Father's Name</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.fatherNamePan}
                            onChange={handleChange('firstNamePan')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="pan">PAN</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pan}
                            onChange={handleChange('pan')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="Address-Line-1">Address Line 1</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.address1}
                            onChange={handleChange('address1')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="Address-Line-2">Address Line 2</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.address2}
                            onChange={handleChange('address2')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="country">Country</InputLabel>
                        {/* <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.country}
                            onChange={handleChange('country')}
                        /> */}
                        <Select native className={classes.bottomLine} name="country" onChange={handleChange('country')}>
                            <option aria-label="None" value="Select Country" />
                            {allCountryOptions(allCountries)}
                        </Select>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="state">State</InputLabel>
                        {/* <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.state}
                            onChange={handleChange('state')}
                        /> */}
                        <Select native className={classes.bottomLine} name="state" onChange={handleChange('state')}>
                            <option aria-label="None" value="Select State" />
                            {allStateOptions(allStates)}
                        </Select>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="city">City</InputLabel>
                        {/* <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.city}
                            onChange={handleChange('city')}
                        /> */}
                        <Select native name="city" className={classes.bottomLine} onChange={handleChange('city')}>
                            <option aria-label="None" value="Select City" />
                            {allCityOptions(allCities)}
                        </Select>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="pin">Pin</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pin}
                            onChange={handleChange('pin')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="dob">DOB</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={moment(values.dob).format('DD-MM-YYYY')}
                            onChange={handleChange('dob')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="mobile-number">Mobile Number</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.mobileNo}
                            onChange={handleChange('mobileNo')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="email-address">Email Address</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.emailAddress}
                            onChange={handleChange('emailAddress')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="standard-adornment-amount">Passport Number</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.passportNumber}
                            onChange={handleChange('passportNumber')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <Typography variant="subtitle1" gutterBottom>
                            Do you have Aadhaar number?
                        </Typography>
                        <div>
                            <FormControl component="fieldset">
                                <RadioGroup defaultValue="aadharNo" aria-label="aadhar" name="customized-radios" className="radio-option">
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="aadharNo" control={<StyledRadio />} label="Aadhaar number" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="enrollmentNo" control={<StyledRadio />} label="Enrollment number" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="notEnrolled" control={<StyledRadio />} label="Not Enrolled" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="aadhar-number">Aadhaar Number</InputLabel>
                                <Input
                                    // disabled
                                    className={classes.bottomLine}
                                    id="standard-adornment-amount"
                                    value={values.aadharNo}
                                    onChange={handleChange()}
                                />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </div>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <Typography variant="subtitle1" gutterBottom>
                            Have you registered under GST?
                        </Typography>
                        <div>
                            <FormControl component="fieldset">
                                <RadioGroup defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option">
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                        </li>
                                        <li>
                                            <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="gst">GST</InputLabel>
                                <Input
                                    // disabled
                                    className={classes.bottomLine}
                                    id="gst"
                                    // value={formvalues.gst}
                                    // onChange={handleChange('amount')}
                                />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    startIcon={<InsertCommentIcon />}
                                    onClick={handleRelevence}
                                >
                                    Add Relevance
                                </Button>
                            </FormControl>
                        </div>
                    </FormControl>
                </Grid>
            </Grid>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
}
